// Deduplicate a Google loader and its destination configurations. Ads uses
// this native loader; GA4 has its own consent-gated worker queue.
export function createGoogleTagLoader(
  inject: (id: string) => void,
  command: (...args: unknown[]) => void,
) {
  let loaded = false;
  const configured = new Set<string>();
  return (id: string) => {
    if (!loaded) {
      loaded = true;
      command('js', new Date());
      inject(id);
    }
    if (!configured.has(id)) {
      configured.add(id);
      command('config', id);
    }
  };
}
